// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nEm5","colBig":"styles_colBig__20ELR","colSmall":"styles_colSmall__2lopp","shopifyNameWrapper":"styles_shopifyNameWrapper__2Kmxd"};